/**
 * @desc 微信二维码
 */
import { QrcodeResult } from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type ShowQrcodeParameter = never

const method = 'GET'
const url = '/auth/wechat/qrcode'

export const showQrcodeApi = (
  params?: ShowQrcodeParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<QrcodeResult>({
    method,
    url,
    params,
    ...config
  })
}

showQrcodeApi.method = method
showQrcodeApi.url = url
